import { recipientCountriesForTariffs } from '../constants/customs';
import { useFulfillmentPlannerContext } from '../fulfillment-planner/context';

const isCountryInTariffsList = (countryCode) => {
  return recipientCountriesForTariffs.includes(countryCode);
};

export const useInternationalRequirements = () => {
  const { shipTo, needsCustoms } = useFulfillmentPlannerContext();
  const isInternational = typeof needsCustoms === 'boolean' ? needsCustoms : needsCustoms?.needsCustoms;
  const applyForTariffs = isInternational && isCountryInTariffsList(shipTo?.countryCode);

  return {
    applyForTariffs,
  };
};
